// services/kinship.js
import axiosInstance from './axiosInstance';

const KINSHIP_API_URL = '/kinship';

const kinshipService = {
  // Obter todos os tipos de parentesco
  async get() {
    try {
      const response = await axiosInstance.get(`${KINSHIP_API_URL}/get.php`);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error('Erro ao obter tipos de parentesco:', error);
      return [];
    }
  }
};

export default kinshipService;
